import dashboardApi from '@modules/dashboard/api';
import { useQuery } from '@tanstack/react-query';

const useGetTrend = (brokerageId?: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['dashboardMonthlyTrend'],
    queryFn: () => dashboardApi.getTrend(brokerageId),
    retry: 2,
    // One hour
    staleTime: 1000 * 60 * 60,
  });

  return {
    data,
    isLoading,
    error,
  };
};

export { useGetTrend };
